"use client";

import { CareerBundleHero } from "@/components/offer/career-bundle-hero";
import { GuestClaimRecovery } from "@/components/offer/guest-claim-recovery";
import { OfferGuaranteeBand } from "@/components/offer/offer-guarantee-band";
import { OfferHeroBand } from "@/components/offer/offer-hero-band";
import { OfferShowcase } from "@/components/offer/offer-showcase";
import { OfferStatsBand } from "@/components/offer/offer-stats-band";
import { useI18n } from "@/components/i18n-provider";
import { useGuestClaim } from "@/hooks/use-guest-claim";

export function OfferContent({ publicMode = false }: { publicMode?: boolean }) {
  const { locale, dictionary } = useI18n();
  const claimCopy = dictionary.dashboard.offerPage.bundle;
  const guestClaim = useGuestClaim({
    locale,
    successMessage: claimCopy.claimSuccessToast,
  });
  const offerPath = `/${locale}/dashboard/offer`;
  const signInPath = `/${locale}/sign-in?redirect=${encodeURIComponent(offerPath)}`;
  const supportPath = `mailto:hai@hyred.id?subject=${encodeURIComponent(
    "Career OS claim recovery",
  )}`;

  return (
    <div className="flex flex-col gap-12">
      {guestClaim.hasPendingClaim ? (
        <GuestClaimRecovery
          isClaiming={guestClaim.isClaiming}
          error={guestClaim.claimError}
          copy={{
            claiming: claimCopy.claiming,
            errors: claimCopy.claimErrors,
            retry: claimCopy.claimRetry,
            switchAccount: claimCopy.claimSwitchAccount,
            signIn: claimCopy.claimSignIn,
            contactSupport: claimCopy.claimContactSupport,
          }}
          onRetry={guestClaim.retry}
          onSwitchAccount={guestClaim.switchAccount}
          signInPath={signInPath}
          supportPath={supportPath}
        />
      ) : null}
      <OfferHeroBand publicMode={publicMode} />
      <OfferStatsBand />
      <div id="career-os-bundle" className="scroll-mt-24">
        <CareerBundleHero publicMode={publicMode} />
      </div>
      <OfferShowcase publicMode={publicMode} />
      <OfferGuaranteeBand />
    </div>
  );
}
